<template>
    <!--  BEGIN SIDEBAR  -->
    <div class="sidebar-wrapper sidebar-theme">
        <nav ref="menu" id="sidebar">
            <div class="shadow-bottom"></div>

            <perfect-scrollbar class="list-unstyled menu-categories" tag="ul" :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }">
                <li class="menu">
              <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#dashboard" aria-controls="dashboard" aria-expanded="false">
                <div class="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-home"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                  <span>{{ $t('dashboard') }}</span>
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-chevron-right"
                  >
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
              </a>

              <ul id="dashboard" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                <li v-can="'show-cassa-page'">
                  <router-link to="/" @click="toggleMobileMenu">
                    {{ $t('home') }}
                  </router-link>
                </li>
                <li v-can="'show-statistics-page'">
                  <router-link to="/employeeStat" @click="toggleMobileMenu">
                    {{ $t('employeeStat') }}
                  </router-link>
                </li>
                <li v-can="'show-export-page'">
                  <router-link to="/exports" @click="toggleMobileMenu">
                    {{ $t('exports') }}
                  </router-link>
                </li>
              </ul>
            </li>
              <li class="menu">
                <a class="dropdown-toggle"
                   data-bs-toggle="collapse"
                   data-bs-target="#settings"
                   aria-controls="settings"
                   aria-expanded="false">
                  <div class="">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="24"
                         height="24"
                         viewBox="0 0 24 24"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="2"
                         stroke-linecap="round"
                         stroke-linejoin="round"
                         class="feather feather-sliders"
                         data-v-5522efca="">
                      <line x1="4" y1="21" x2="4" y2="14"></line>
                      <line x1="4" y1="10" x2="4" y2="3"></line>
                      <line x1="12" y1="21" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12" y2="3"></line>
                      <line x1="20" y1="21" x2="20" y2="16"></line>
                      <line x1="20" y1="12" x2="20" y2="3"></line>
                      <line x1="1" y1="14" x2="7" y2="14"></line>
                      <line x1="9" y1="8" x2="15" y2="8"></line>
                      <line x1="17" y1="16" x2="23" y2="16"></line>
                    </svg>
                    <span>{{ $t('settings') }}</span>
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-right"
                    >
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </a>

                <ul id="settings" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                  <li>
                    <router-link to="/settings/employees" @click="toggleMobileMenu">
                      {{ $t('employees') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/settings/category/list" @click="toggleMobileMenu">
                      {{ $t('categories') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/settings/product/list" @click="toggleMobileMenu">
                      {{ $t('products') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/settings/discount/list" @click="toggleMobileMenu">
                      {{ $t('discounts') }}
                    </router-link>
                  </li>
                </ul>
              </li>
              <li class="menu" v-can="'show-administration-page'">
                <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#users" aria-controls="users" aria-expanded="false">
                  <div class="">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-users"
                    >
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                    <span>{{ $t('administration') }}</span>
                  </div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-right"
                    >
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </a>

                <ul id="users" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                  <li v-can="'show-users-page'">
                    <router-link to="/users" @click="toggleMobileMenu">{{ $t('users') }}</router-link>
                  </li>
                  <li v-can="'show-roles-page'">
                    <router-link to="/users/roles" @click="toggleMobileMenu">{{ $t('roles') }}</router-link>
                  </li>
                  <li v-can="'show-permission-page'">
                    <router-link to="/users/permissions" @click="toggleMobileMenu">{{ $t('permissions') }}</router-link>
                  </li>
                </ul>
              </li>
            </perfect-scrollbar>
        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>

<script setup>
    import { onMounted, ref } from 'vue';
    import { useStore } from 'vuex';
    const store = useStore();

    const menu_collapse = ref('dashboard');

    onMounted(() => {
        const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
        if (selector) {
            const ul = selector.closest('ul.collapse');
            if (ul) {
                let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            } else {
                selector.click();
            }
        }
    });

    const toggleMobileMenu = () => {
        if (window.innerWidth < 991) {
            store.commit('toggleSideBar', !store.state.is_show_sidebar);
        }
    };
</script>
